import {type} from 'arktype';
import {expectEither, HttpClient} from '~/library/network-facade';

// Responses
//
// 200
// {code: 100, message: "Too many verification attempts. Please try again later.", error_name: "RATE_LIMIT"}
// {code: 100, message: "Invalid phone number.", error_name: "INVALID_PHONE"}
// {code: 100, message: "Service temporarily unavailable. Please try again later.", error_name: "ERROR"}
// {code: 10, message: "Awaiting dispatch."}
// {code: 1, message: "Successful dispatch."}
// {code: 0, message: "Successful delivery."}

export const SmsErrorStatus = type('"RATE_LIMIT" | "INVALID_PHONE" | "ERROR"');
export type SmsErrorStatus = typeof SmsErrorStatus.infer;

export type SmsDeliveryStatus = 'DELIVERED' | SmsErrorStatus;
export const SmsDeliveryStatus = SmsErrorStatus.or("'DELIVERED'");

type SmsStatusErrorResponse = ({} & (typeof SmsStatusErrorResponse)['~standard']['types'])['output'];
const SmsStatusErrorResponse = type({
    code: '100',
    error_name: SmsErrorStatus,
});

type SmsStatusInfoResponse = ({} & (typeof SmsStatusInfoResponse)['~standard']['types'])['output'];
const SmsStatusInfoResponse = type({code: '10 | 1 | 0', message: 'string'});

export async function fetchSmsStatus(
    http: HttpClient,
    uuid: string
): Promise<SmsStatusErrorResponse | SmsStatusInfoResponse> {
    const res = await http(`v1/public/tenant/sms/${uuid}`).then(
        ...expectEither({
            200: SmsStatusErrorResponse.or(SmsStatusInfoResponse),
            404: null,
        })
    );

    switch (res.status) {
        case 200: {
            return res.json;
        }
        // patching server response
        case 404: {
            return {code: 100, error_name: 'INVALID_PHONE'};
        }
        case 'Abort': {
            throw res.reason;
        }
    }
}
